import styled from "styled-components";

export const HR = styled.hr`
  background-color: rgba(0, 0, 0, 0.3);
  color: inherit;
  width: 100%;
  margin-bottom: 24px;
  margin-top: 0;
`;
